import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { Trans } from '@lingui/macro';
import styles from './style.css';

class ConfirmPasswordModal extends Component {
  render() {
    return (
      <div>
        <Modal
          style={{ marginTop: '125px' }}
          show={this.props.show}
          onHide={this._onClickClose}
        >
          <Modal.Header
            style={{ backgroundColor: '#ffffff', borderBottom: 'none' }}
            closeButton
          >
            <Modal.Title className={styles.title}>
              <div>
                <Trans>Are you sure to change password?</Trans>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={styles.body}>
            <Trans>
              By changing password, you will be signed out from all other
              devices where you were signed in previously
            </Trans>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: 'none', marginRight: '15px' }}>
            <button
              type="button"
              style={{ paddingLeft: '25px', paddingRight: '25px' }}
              className="btn btn-default"
              onClick={this._onClickClose}
            >
              <Trans>Discard Changes</Trans>
            </button>
            <button
              type="submit"
              style={{ paddingLeft: '25px', paddingRight: '25px' }}
              className="btn btn-primary"
              onClick={this._onClickSave}
            >
              <Trans>Save Changes</Trans>
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  _onClickClose = e => {
    e.stopPropagation();
    this.props.close();
  };

  _onClickSave = e => {
    e.preventDefault();
    this.props.onConfirm();
  };
}

export default ConfirmPasswordModal;
